(function(){
  var reduced = window.matchMedia && matchMedia('(prefers-reduced-motion: reduce)').matches;
  var hdr = document.querySelector('header.fs-site');
  function onScroll(){
    if(hdr) hdr.classList.toggle('scrolled', window.scrollY > 12);
    var kt = document.getElementById('koi-top');
    if(kt) kt.classList.toggle('show', window.scrollY > 700);
  }
  window.addEventListener('scroll', onScroll, {passive:true});
  var targets = document.querySelectorAll('.pcard,.sec-head,.sv,.cut,.rev,.art,.set,.svc-grid .c,.chip-c,.fs-deal,.pill,.ban');
  if(!reduced && 'IntersectionObserver' in window && targets.length){
    var io = new IntersectionObserver(function(entries){
      entries.forEach(function(e){ if(e.isIntersecting){ e.target.classList.add('fx-in'); io.unobserve(e.target); } });
    }, {rootMargin:'0px 0px -6% 0px'});
    var i = 0;
    targets.forEach(function(el){
      var r = el.getBoundingClientRect();
      if(r.top < window.innerHeight){ return; }
      el.classList.add('fx');
      el.style.transitionDelay = ((i % 4) * 70) + 'ms';
      i++;
      io.observe(el);
    });
  }
  var b = document.querySelector('.brands');
  if(b && !b.querySelector('.brands-track')){
    var track = document.createElement('div');
    track.className = 'brands-track';
    while(b.firstChild){ track.appendChild(b.firstChild); }
    track.innerHTML = track.innerHTML + track.innerHTML;
    b.appendChild(track);
  }
  if(!document.getElementById('koi-top')){
    var kt = document.createElement('button');
    kt.id = 'koi-top';
    kt.className = 'koi-top';
    kt.setAttribute('aria-label', 'Nach oben');
    kt.innerHTML = '<svg viewBox="0 0 24 24"><path d="M12 21s-6-4-6-10c0-3.5 2.5-7 6-9 3.5 2 6 5.5 6 9 0 6-6 10-6 10Z"/><path d="M12 21c-1.5-2-1.5-4 0-6 1.5 2 1.5 4 0 6Z"/><circle cx="10.4" cy="8.2" r=".5"/><circle cx="13.6" cy="8.2" r=".5"/></svg>';
    kt.addEventListener('click', function(){ window.scrollTo({top:0, behavior: reduced ? 'auto' : 'smooth'}); });
    document.body.appendChild(kt);
  }
  // Hamburger / Drawer
  var burger = document.getElementById('fs-burger');
  var drawer = document.getElementById('fs-drawer');
  function setDrawer(open){
    if(!drawer) return;
    drawer.classList.toggle('open', open);
    drawer.setAttribute('aria-hidden', String(!open));
    if(burger) burger.setAttribute('aria-expanded', String(open));
    document.documentElement.style.overflow = open ? 'hidden' : '';
  }
  if(burger && drawer){
    burger.addEventListener('click', function(){ setDrawer(!drawer.classList.contains('open')); });
    drawer.addEventListener('click', function(e){
      if(e.target.closest('[data-drawer-close]') || e.target.closest('a')) setDrawer(false);
    });
    document.addEventListener('keydown', function(e){ if(e.key === 'Escape') setDrawer(false); });
  }
  onScroll();
})();